
export const pageCacheClear = () => {
  let pageKey = window.session.formatKey("page#")
  Object.keys(window.sessionStorage)
    .filter((key) => key.indexOf(pageKey) === 0)
    .forEach((key) => {
      window.sessionStorage.removeItem(key)
    })
}

export const savePageCache = (id,data) =>{
  window.session.save("page#" + id,data)
}


export const getPageCache = (id) =>{
  return window.session.get("page#" + id)
}

